import React from 'react'
import {HStack, VStack, Skeleton} from '@chakra-ui/react'
import {ProductSkeleton} from '_uiComponents'
import {useViewport} from '_customHooks'

/**
 * @name ProductDetailsSkeleton
 *
 * @component
 *
 * @description
 * Renders the skeleton of the ProductDetails component.
 * *
 * @returns {React.FC} - The rendered skeleton component.
 */
const ProductDetailsSkeleton: React.FC = () => {
    const {isMobile} = useViewport()

    return (
        <VStack w={'100%'} h={'200vh'} gap={isMobile ? '60px' : '80px'}>
            {isMobile ? (
                <>
                    <Skeleton w={'100%'} aspectRatio={0.755} />
                    <Skeleton mx={'24px'} h={'66px'} w={'stretch'} />
                    <Skeleton mx={'24px'} h={'42px'} w={'stretch'} position={'fixed'} bottom={'30px'} />
                </>
            ) : (
                <>
                    <HStack w={'100%'} alignItems={'flex-start'}>
                        <Skeleton flexBasis={'46%'} aspectRatio={0.755} />
                        <Skeleton flexBasis={'8%'} />
                        <VStack alignItems={'flex-start'} h={'100%'} flexGrow={1} gap={'30px'} py={'20px'} pr={'100px'}>
                            <Skeleton h={'20px'} w={'50%'} />
                            <Skeleton h={'85px'} w={'100%'} />
                            <Skeleton h={'120px'} w={'100%'} />
                            <Skeleton h={'42px'} w={'100%'} />
                            <Skeleton h={'100px'} w={'100%'} />
                        </VStack>
                    </HStack>

                    <VStack w={'100%'} pl={'60px'} gap={'50px'} overflow={'hidden'}>
                        <HStack w={'100%'} gap={'24px'}>
                            <Skeleton h={'45px'} w={'130px'} />
                            <Skeleton h={'45px'} w={'130px'} />
                        </HStack>
                        <HStack w={'120%'} ml={0} mr={'auto'}>
                            {Array.from({length: 5}, (_, index) => (
                                <ProductSkeleton key={`skeleton-${index}`} />
                            ))}
                        </HStack>
                    </VStack>
                </>
            )}
        </VStack>
    )
}

ProductDetailsSkeleton.displayName = 'ProductDetailsSkeleton'

export {ProductDetailsSkeleton}
